import React from "react";
import { Stack } from "@mui/material";
import AttachFile from "../components/changeBoard/attachFile/AttachFile";
import AttachmentItem from "./AttchementItem";

function AttachmentList({
  attachments,
  isMobile,
  totalRecord,
  cardId,
  handleSlideShowAttachment,
  handleView,
  handleDownload,
  handleDelete,
}) {
  const hasAttachments = totalRecord > 0;

  return (
    <>
      {hasAttachments &&
        (isMobile ? (
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            my={1}
            marginTop={2.5}
            className="mobile-attachment-list-container"
          >
            <p
              className="attachment-para mobile-attachment-para"
              style={{ marginTop: 0 }}
            >
              Attachments ({totalRecord}){" "}
            </p>
            <AttachFile cardId={cardId} isIconBtn={true} />
          </Stack>
        ) : (
          <p className="attachment-para">Attachments ({totalRecord})</p>
        ))}
      {hasAttachments && (
        <div className={isMobile ? "mobile-attachment-box" : "attachment-box"}>
          {attachments.map((item) => (
            <AttachmentItem
              key={item.card_attachment_id}
              item={item}
              isMobile={isMobile}
              handleSlideShowAttachment={handleSlideShowAttachment}
              handleView={handleView}
              handleDownload={handleDownload}
              handleDelete={handleDelete}
            />
          ))}
          {!isMobile && <AttachFile cardId={cardId} isIconBtn={true} />}
        </div>
      )}
    </>
  );
}

export default React.memo(AttachmentList);
